import React, { useState, useEffect, useRef, lazy } from "react";
import BonusItem from '../../Components/Bonuses/BonusItem.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import { Header } from '../../Components/Layout/Header.jsx';
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx';
import { Game } from '../../Components/Game/Game.jsx';
import { useHistory, useLocation } from "react-router-dom";

export default function Bonuses(props) {

    const promotions = [
    ]
    const [promotionsData, setPromotionsData] = useState(null);
    const [challenges, setChallenges] = useState(null);
    const [superKisaForecast, setSuperKisaForecast] = useState(null);
    const [cashbackHeight, setCashbackHeight] = useState(null);
    const cashbackIframeRef = useRef(null);
    const superAvanturaIframeRefs = useRef({});
    const [iframeHeights, setIframeHeights] = useState({});
    const history = useHistory();


    /**** MY METHODS *****/
    useEffect(() => {
        getData();
        getSuperKisaForecast();

        window.scrollTo(0, 0);

        window.addEventListener("message", receiveMessages);

        return () => {
            window.removeEventListener("message", receiveMessages);
        };
    }, []);

    useEffect(() => {
        let nadimak = props.user?.nadimak;

        getData(nadimak);
        getChallenges();
    }, [props.user]);

    //casino.utils.createPageGoogleTagManagerEvent('Promocije', 'Sve promocije', 'casino', this.props.user);
    function getData(nadimak) {

        casino.repos.casinoPromotionsRepo.list(true, null, nadimak).then(result => {
            //Custom komponente postavimo na vrh
            let customCodes = ['first-depozit', 'superklub', 'drops-and-wins', 'super-kisa', 'vip', 'casino-izazovi', 'casino-utrke', 'super-spin', 'cashback', 'super-avantura'];
            setCostomComponentActive(customCodes, result);
            /*********************************/

            setPromotionsData(result);
        });
    }

    function getSuperKisaForecast() {
        casino.repos.casinoSuperkisaForecastRepo.get().then((result) => {
            setSuperKisaForecast(result);
        });
    }

    function getChallenges() {
        if (props.user) {
            casino.repos.superklubLoyaltyRepo.get().then((result) => {
                setChallenges(result.data.challenges[0].challenges);
            });
        }
    }

    function setCostomComponentActive(customCodes, components) {
        customCodes.forEach((code) => {
            var index = components.findIndex(x => x.code == code);
            if (components[index])
                components[index].finished = false;
        });
    }

    function getPromotions(showActive) {
        let active = promotionsData.filter((bonus) => { return !bonus.finished }).sort((a, b) => {
            if (!props.user) {
                if (a.code === "first-depozit") return -1;
                if (b.code === "first-depozit") return 1;
            }
            return a.order > b.order ? 1 : -1;
        });
        let inactive = promotionsData.filter((bonus) => { return bonus.finished }).sort((a, b) => a.endDate < b.endDate ? 1 : -1);
        return showActive ? active : inactive;
    }

    // iFrame communication start
    const sendRenderMobile = () => {
        const cashbackWindow = cashbackIframeRef.current?.contentWindow;

        if (!cashbackWindow) {
            console.error("No iframes are ready");
            return;
        }

        const message = {
            type: "renderContext",
            renderMobile: true,
        };

        // Send message to cashback iframe if it exists
        if (cashbackWindow) {
            cashbackWindow.postMessage(message, "*");
        }
    };

    const receiveMessages = (message) => {
        if (message.data.type == "urlParameter") {
            history.push(`/promotions${message.data.urlParam}`);
        }

        if (message.data.type == "cashbackHeight") {
            setCashbackHeight(message.data.scrollHeight + "px");
        }

        if (message.data.type?.endsWith("-height")) {
            const adventureType = message.data.type.replace("-height", "");
            const scrollHeight = message.data.scrollHeight;

            //console.log("Adventure type height received:", adventureType, scrollHeight);

            // You can store this height in state if needed, e.g.
            setIframeHeights(prev => ({ ...prev, [adventureType]: scrollHeight }));
        }
    };
    // iFrame communication end

    const renderAvantura = (promotion) => {
        //console.log('mobpromo', promotion)
        const adventureType = promotion.code;

        const widgetSize = promotion.Size == 2 ? " component-main-div-medium" : " component-main-div-big";

        //"component-main-div-big" 3 4
        //"component-main-div-medium" 2
        //"component-main-div-small" 1

        const handleIframeLoad = () => {
            const iframeWindow = superAvanturaIframeRefs.current[adventureType]?.contentWindow;
            if (iframeWindow) {
                iframeWindow.postMessage({
                    type: "adventureType",
                    adventureType: adventureType
                }, "*");
                iframeWindow.postMessage({
                    type: "promotion",
                    promotion: promotion
                }, "*");
            }
        };

        //console.log(iframeHeights, 'ih')

        return (
            <div className="widget-container"
                key={promotion.code}
                style={{ height: iframeHeights[adventureType] - (!promotion.finished ? 20 : 0) || 100 + '%' }}
            >
                <iframe
                    className={"super-avantura" + (widgetSize) + (promotion.finished ? " finished" : "")}
                    ref={(el) => superAvanturaIframeRefs.current[adventureType] = el}
                    title="SuperAvantura"
                    src={`${casino.config.casinoModulesUrl}super-avantura/index.html?path=widget&sifraavanture=${adventureType}`}
                    scrolling="no"
                    onLoad={handleIframeLoad}
                />
            </div>
        );
    }

    return (
        <>
            <MetaTags title="Online Casino Bonus Dobrodošlice i Promocije | SuperCasino | SuperCasino" description="100% Bonusa. Happy hour utrka - 1.000kn svaki dan. Najbolje online casino promocije na jednom mejstu. Pridruži se dokazano najboljem casinu." />
            <Header key="header" {...props}></Header>
            <div className='white-background'>
                <div id="page-wrapper" className="max-width-70 margin-center no-padding-on-mobile" >
                    <div style={{ height: '62px', display: 'block' }} className='mobile-hidden'></div>
                    <div className="bonus-page-content white-background">
                        <h2>Promocije i turniri</h2>
                        <div className="bonusi-page-container active">
                            {promotionsData && promotions && getPromotions(true).map((promotion, index) => {
                                if (promotion.code == 'cashback') {
                                    return (
                                        <div className="widget-container"
                                            key={promotion.code}
                                            style={{ height: cashbackHeight, marginBottom: "27px" }}
                                        >
                                            <iframe
                                                style={{ border: "none", width: "100%" }}
                                                ref={cashbackIframeRef}
                                                title="Casino Cashback"
                                                src={`${casino.config.casinoModulesUrl}cashback/index.html?path=widget`}
                                                scrolling="no"
                                                height={cashbackHeight}
                                                onLoad={sendRenderMobile}
                                            />
                                        </div>
                                    )
                                }

                                if (promotion.code.includes('super-avantura')) {
                                    return renderAvantura(promotion);
                                }

                                else {
                                    return <BonusItem key={"bonus" + index} promotion={promotion} {...props} challenges={challenges} superKisaForecast={superKisaForecast} />
                                }
                            })}
                        </div>
                        <h2>Završene promocije</h2>
                        <div className="bonusi-page-container">
                            {promotionsData && promotions && getPromotions(false).map((promotion, index) => {
                                if (promotion.code.includes('super-avantura')) {
                                    return renderAvantura(promotion);
                                } else {
                                    return <BonusItem key={"bonus" + index} promotion={promotion} {...props} challenges={challenges} />

                                }
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <ObavijestiCasino {...props}></ObavijestiCasino>
        </>
    );
};

